import {
  SET_TOURNAMENT_RESTRICTION
} from './constants';

const initialState = {
  enforceMinimumCaptainAge: false,
  minimumCaptainAge: null,
  showCalculatedDivisionToCaptain: false,
  requireRosterBeforeCheckout: false,
  restrictBowlersToActiveMembership: false,
  restrictBowlersToYouthMembership: false,
  blockFailedDivisionCalculation: false,
  termsUrl: ''
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_TOURNAMENT_RESTRICTION: {
      const enforceMinimumCaptainAge = payload.enforceMinimumCaptainAge || initialState.enforceMinimumCaptainAge;
      const minimumCaptainAge = payload.minimumCaptainAge || initialState.minimumCaptainAge;
      const showCalculatedDivisionToCaptain = payload.showCalculatedDivisionToCaptain || initialState.showCalculatedDivisionToCaptain;
      const requireRosterBeforeCheckout = payload.requireRosterBeforeCheckout || initialState.requireRosterBeforeCheckout;
      const restrictBowlersToActiveMembership = payload. restrictBowlersToActiveMembership || initialState. restrictBowlersToActiveMembership;
      const restrictBowlersToYouthMembership = payload.restrictBowlersToYouthMembership || initialState.restrictBowlersToYouthMembership;
      const blockFailedDivisionCalculation = payload.blockFailedDivisionCalculation || initialState.blockFailedDivisionCalculation;

      return {
        ...state,
        enforceMinimumCaptainAge: enforceMinimumCaptainAge,
        minimumCaptainAge: minimumCaptainAge,
        showCalculatedDivisionToCaptain: showCalculatedDivisionToCaptain,
        requireRosterBeforeCheckout: requireRosterBeforeCheckout,
        restrictBowlersToActiveMembership: restrictBowlersToActiveMembership,
        restrictBowlersToYouthMembership: restrictBowlersToYouthMembership,
        blockFailedDivisionCalculation: blockFailedDivisionCalculation
      };
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/reducer.js